import React from 'react';
import DataManager from './DataManager.js';

let qs = (function getQsParams() {
    var query = window.location.search.substring(1);
    var output = {};
    if (query.length > 0){
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            var value = pair[1] ? decodeURIComponent(pair[1]) : null;
            output[decodeURIComponent(pair[0])] = value ? value : true;
        }
    }
    return output;
})();

function getQs(key){
    if (qs[key]){
        return qs[key];
    }else{
        return false;
    }
}

const DEFAULT_STATE = {
    debug: getQs('debug'),
    whitelabel: getQs('whitelabel'),
    ready: false,
    responses: null,
    weightings: null,
    rankings: null,
    bullBear: null,
    selectedFunds: [],
    showingReport: false,
    modal: null,
    modalImage: null,
    currentStep: 0,
    hasVerified: false,
    preparedBy: null,
    preparedFor: null,
    logo: null,
    logoName: null,
    adviserLogo: null,
    adviserLogoName: null,
    comments: null,
    userInfo: null,
    finalOptimal: null,
    selectedPoints: '',
    growthTab:0,
};

export const Context = React.createContext(DEFAULT_STATE);

export default class Provider extends React.Component {
    state = DEFAULT_STATE;

    constructor(props){
        super(props);    
        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.hideReport = this.hideReport.bind(this);
        this.showReport = this.showReport.bind(this);
        this.setFunds = this.setFunds.bind(this);
        this.setResponse = this.setResponse.bind(this);
        this.getSimplifiedWeightings = this.getSimplifiedWeightings.bind(this);
        window.Provider = this;
    }

    componentDidMount(){
       // console.log('Version 2.1');
        this.dataManager = new DataManager(() => {            
            if (this.state.debug){
                //let responses = JSON.parse('{"1":{"selected":{"id":"1","text":"Review process"},"altSelected":null,"altOther":null},"2":{"selected":{"id":"1","text":"Yes","outputText":"has"},"altSelected":{"text":"Glide Path Change"},"altOther":null},"3":{"selected":{"id":"1","text":"Yes","outputText":"has"},"altSelected":{"text":"New team members"},"altOther":null},"4":{"selected":{"id":"2","text":"No, the fund manager has deviated from the investment strategy<br/>stated in the prospectus","outputText":"has not"},"altSelected":null,"altOther":null},"5":{"selected":{"id":"1","text":"Yes","outputText":"has"},"altSelected":{"text":"Objective changed from lowest dispersion of outcomes to highest possible returns."},"altOther":null},"6":{"selected":{"id":"1","text":"Yes","outputText":"Participant savings rates have not changed since the plan was last reviewed and additional considerations should be made regarding these changes."},"altSelected":null,"altOther":null},"7":{"selected":{"id":"2","text":"Terminated","outputText":"The firm has terminated or started a Defined Benefit plan option since the plan was last reviewed and additional considerations should be made regarding these changes."},"altSelected":null,"altOther":null},"8":{"selected":{"id":"2","text":"35-50 years old"},"altSelected":null,"altOther":null},"9":{"selected":{"id":"2","text":"Participants with 30-16 years to retirement<br/>(35-50 years old)"},"altSelected":null,"altOther":null},"10":{"selected":{"id":"2","text":"62-66"},"altSelected":null,"altOther":null},"11":{"selected":{"id":"1","text":"Yes","outputText":"Employees also participate in a Defined Benefit plan"},"altSelected":null,"altOther":null},"12":{"selected":{"id":"3","text":"$61k-95k"},"altSelected":null,"altOther":null},"13":{"selected":{"id":"1","text":"Low (Less than 10%)"},"altSelected":null,"altOther":null},"14":{"selected":{"id":"2","text":"Around U.S. Average"},"altSelected":null,"altOther":null},"15":{"selected":{"id":"3","text":"Take a lump sum withdrawal/IRA Rollover"},"altSelected":null,"altOther":null},"16":{"selected":{"id":"3","text":"Focused on reducing dispersion of outcomes by limiting large potential losses, accepting lower capital growth over time."},"altSelected":null,"altOther":null},"17":{"selected":{"id":"2","text":"Not sure","outputText":"It is uncertain whether or not it is important for the target-date strategy to serve as an income solution for retirees remaining in the plan."},"altSelected":null,"altOther":null},"18":{"selected":{"id":"2","text":"Equal emphasis on capital growth and preservation"},"altSelected":null,"altOther":null},"19":{"selected":{"id":"2","text":"No change in participant behavior, most likely to stick with their allocations"},"altSelected":null,"altOther":null},"name":"ABC Company","resources":"Resource 1, Resource 2"}');
                let responses = JSON.parse('{"1":{"selected":{"id":"1","text":"Review process"},"altSelected":null,"altOther":null},"2":{"selected":{"id":"2","text":"No","outputText":"has not"},"altSelected":null,"altOther":null},"3":{"selected":{"id":"2","text":"No","outputText":"has not"},"altSelected":null,"altOther":null},"4":{"selected":{"id":"1","text":"Yes, the fund manager is carrying out the investment strategy<br/>per the fund’s prospectus","outputText":"has"},"altSelected":null,"altOther":null},"5":{"selected":{"id":"2","text":"No","outputText":"has not"},"altSelected":null,"altOther":null},"6":{"selected":{"id":"1","text":"Yes","outputText":"Participant savings rates have not changed since the plan was last reviewed and additional considerations should be made regarding these changes."},"altSelected":null,"altOther":null},"7":{"selected":{"id":"1","text":"Started","outputText":"The firm has terminated or started a Defined Benefit plan option since the plan was last reviewed and additional considerations should be made regarding these changes."},"altSelected":null,"altOther":null},"8":{"selected":{"id":"2","text":"35-50 years old"},"altSelected":null,"altOther":null},"9":{"selected":{"id":"2","text":"Participants with 30-16 years to retirement<br/>(35-50 years old)"},"altSelected":null,"altOther":null},"10":{"selected":{"id":"2","text":"62-66"},"altSelected":null,"altOther":null},"11":{"selected":{"id":"2","text":"No","outputText":"Employees do not participate in a Defined Benefit plan"},"altSelected":null,"altOther":null},"12":{"selected":{"id":"3","text":"$61k-95k"},"altSelected":null,"altOther":null},"13":{"selected":{"id":"2","text":"Medium (10-20%)"},"altSelected":null,"altOther":null},"14":{"selected":{"id":"2","text":"6% to 10%","outputText":"6% to 10%"},"altSelected":null,"altOther":null},"15":{"selected":{"id":"3","text":"Take a lump sum withdrawal/IRA Rollover"},"altSelected":null,"altOther":null},"16":{"selected":{"id":"2","text":"Seeks to provide participants moderate long-term return potential by accepting moderate volatility and the potential for moderate losses"},"altSelected":null,"altOther":null},"17":{"selected":{"id":"3","text":"Not important","outputText":"It is not important for the target-date strategy to serve as an income solution for retirees remaining in the plan."},"altSelected":null,"altOther":null},"18":{"selected":{"id":"2","text":"Equal emphasis on capital growth and preservation"},"altSelected":null,"altOther":null},"19":{"selected":{"id":"2","text":"No change in participant behavior, most likely to stick with their allocations"},"altSelected":null,"altOther":null},"name":"DEF Plan", "resources":"Resource 1, Resource 2"}');
                let weightings = this.dataManager.calculateWeightings(responses);
                let bullBear = this.dataManager.calculateBullBear(weightings);
                let rankings = this.dataManager.calculateRankings(weightings);
                let selectedFunds = JSON.parse('{"AmericanCentury":{"id":"AmericanCentury","ticker":"ARLIX","display":"American Century One Choice","rankRaw":41.26863636363637,"Growth_R":"74","Market_R":"10","Macro_R":"48","Income_R":"2","rank":41.3,"grouped":null,"zScore":-2.0610772730218225,"quartile":1},"TIAAIndex":{"id":"TIAAIndex","ticker":"TLYIX","display":"TIAA-CREF Lifecycle Index","rankRaw":42.78794545454546,"Growth_R":"19","Market_R":"64","Macro_R":"64","Income_R":"24","rank":42.8,"grouped":null,"zScore":-1.7185658894584295,"quartile":1},"TRowe Target":{"id":"TRowe Target","ticker":"RPGRX","display":"T. Rowe Price Target","rankRaw":44.30978181818181,"Growth_R":"67","Market_R":"24","Macro_R":"38","Income_R":"36","rank":44.3,"grouped":null,"zScore":-1.3760545058950362,"quartile":1},"GuideStone":{"id":"GuideStone","ticker":"GMHZX","display":"Guidestone Funds MyDestination","rankRaw":44.52812727272727,"Growth_R":"60","Market_R":"26","Macro_R":"57","Income_R":"41","rank":44.5,"grouped":null,"zScore":-1.3303863214199163,"quartile":1},"TIAA-CREF":{"id":"TIAA-CREF","ticker":"TCIIX","display":"TIAA-CREF Lifecycle","rankRaw":44.56010909090908,"Growth_R":"10","Market_R":"81","Macro_R":"45","Income_R":"22","rank":44.6,"grouped":null,"zScore":-1.3075522291823565,"quartile":1},"GreatWest":{"id":"GreatWest","ticker":"MXHLX","display":"Great-West Lifetime","rankRaw":44.62552727272727,"Growth_R":"36","Market_R":"57","Macro_R":"14","Income_R":"10","rank":44.6,"grouped":null,"zScore":-1.3075522291823565,"quartile":1}}');

                this.setState({ ready: true, currentStep: 10, hasVerified: true }, () => {
                    this.setState({ responses, weightings, bullBear, rankings, selectedFunds, preparedBy: 'Jared Shockcor', userInfo: { 
                        firstName: 'Jared', 
                        lastName: 'Shockcor', 
                        email: 'addexm@gmail.com',
                        company: 'ABC',
                        phone: '555-555-5555',
                        certified: true
                    }});
                });   
            }else{
                this.setState({ ready: true });
            }
        });
    }

    /* View State */
    showModal(modalTitle, modalContent, modalClass, modalDoneFunction, modalDoneText, footer, forceClose, modalImage){
        this.setState({ modal: { title: modalTitle, content: modalContent, className: modalClass, onDone: modalDoneFunction, modalImage: modalImage, doneText: modalDoneText, footer: footer, forceClose: !!forceClose } });
    }

    hideModal(){
        this.setState({ modal: null });
    }

    hideReport(){
        this.setState({ showingReport: false });
    }

    showReport(preparedFor, preparedBy, includeMethodology, comments, portrait, summary, quartiles,glidePath,glideOptimized, risk){
        //console.log(portrait,summary,quartiles)
        this.setState({ preparedFor, preparedBy, 
            showingReport: true, 
            reportIncludesMethodology: includeMethodology,
            comments, portrait, summary, quartiles, glidePath, glideOptimized, risk });
    }

    setLogo(logo, logoName){
        this.setState({ logo, logoName });
    }

    setAdviserLogo(adviserLogo, adviserLogoName){
        this.setState({ adviserLogo, adviserLogoName });
    }
    
    /* Getters and Setters */
    isDebug(){
        return this.state.debug;
    }

    setResponse(id, response){
        let responses = Object.assign({}, this.state.responses);
        responses[id] = response;
               // debugger;
        let weightings = this.dataManager.calculateWeightings(responses);
        let bullBear = this.dataManager.calculateBullBear(weightings);
        let rankings = this.dataManager.calculateRankings(weightings);
        this.setState({ responses, weightings, rankings, bullBear });   
    }

    setUserInfo(userInfo){
        window.userInfo = userInfo;
        this.setState({ userInfo });  
    }

    setFinalOptimal(finalOptimal){
        this.setState({finalOptimal:finalOptimal})
    }

    getFinalOptimal(){
        return this.state.finalOptimal
    }

    getResponses(){
        return this.state.responses;
    }
                    
    getOriginFunds(){
        return this.dataManager.funds
    }

    setFunds(funds){
        this.setState({ selectedFunds: funds });
    }

    getFunds(){
        return this.state.selectedFunds;
    }

    setSelectedPoints(funds){
        this.setState({ selectedPoints: funds });
    }

    getSelectedPoints(){
        return this.state.selectedPoints
    }
    
    getRankings(){
        return this.state.rankings;
    }

    getSimplifiedWeightings(){
        return this.dataManager.calculateSimpleWeightings(this.state.weightings);
    }

    getGlides(){
        return this.dataManager.glides;
    }

    getOptimals(){
        return this.dataManager.optimals;
    }

    setGrowthTab(value){
        this.setState({growthTab:value})
    }

    getGrowthTab(){
        return this.state.growthTab;
    }

    async submitAciData(eventName, includesMethodology){
        //console.log('Submitting ACI Data');    
        let configData = await this.dataManager.getConfig();

        try{
            var selectionData = { 
                timestamp: new Date(),
                eventName: eventName,
                includesMethodology: includesMethodology,
                preparedFor: this.state.preparedFor,
                preparedBy: this.state.preparedBy,
                selectedFunds: Object.values(this.state.selectedFunds), 
                responses: Object.keys(this.state.responses).map(key => {
                    if (key === 'name' || key === 'resources'){
                        return { qid: key, value: this.state.responses[key] };
                    }else{
                        return Object.assign({}, this.state.responses[key], { qid: key });
                    }
                }),
                weightings: this.state.weightings
            };
            selectionData = Object.assign(selectionData, this.props.userInfo);
            //console.log(selectionData);
            selectionData = JSON.stringify(selectionData);
            selectionData = selectionData.replace(/<br\/>/g, ' ');

            //console.log('Data being sent:');
            //console.log(selectionData);

            fetch(configData.tokenUri, {
                headers: {
                    'clientId': configData.clientId,
                    'clientSecret': configData.clientSecret,
                    'Accept': 'application/json'
                },
            }).then(response => {
                return response.json()
            }).then(data => {
                let token = data.access_token;
                // fetch(configData.postUri, {
                //     method: 'POST',
                //     mode: 'cors',
                //     headers: {
                //         'Authorization': 'Bearer ' + token,
                //         'Content-Type': 'application/json'
                //     },
                //     body: selectionData        
                // }).then(async postResponse => {
                //     let responseText = await postResponse.text();
                //     console.log(responseText);
                // });
            });




            /*if (this.state.debug)return;
            var $iframe = document.getElementById('aciIframe');
            if ($iframe.length === 0)return;            
            var currentUrl = $iframe.getAttribute('src');
            console.log('Current url:', currentUrl);
            var newUrl = currentUrl + '?data=' + encodeURIComponent(selectionData);
            $iframe.setAttribute('src', newUrl);
            console.log('New url:', newUrl);*/
        }catch(e){
            console.log(e.message);
        }
    }

    render() {
        if (!this.state.ready)return null;
        return (
            <Context.Provider
                value={{
                    ...this.state,
                    setOverlayOpen: this.setOverlayOpen,
                    showModal: this.showModal,
                    hideModal: this.hideModal,
                    setFunds: this.setFunds,
                    modalImage: this.modalImage,
                    dataManager: this.dataManager,
                    showReport: this.showReport,
                    hideReport: this.hideReport,
                    setCurrentStep: this.setCurrentStep,
                    submitAciData: this.submitAciData,
                    setLogo: this.setLogo,
                    setAdviserLogo: this.setAdviserLogo
                }}
            >
                {this.props.children}
            </Context.Provider>
        );
    }
}